import React from 'react';
import SiteModule from './site_module';

interface SiteModulePlaceholderProps {
  numPlaceholderLines?: number;
}

export default function SiteModulePlaceholder({ numPlaceholderLines = 3 }: SiteModulePlaceholderProps) {

  function randomLineWidthPercent() {
    return `${(Math.random() * (27 - 22)) + 22}%`;
  }

  return (
    <SiteModule>
      {[...Array(numPlaceholderLines)].map((_, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <span key={idx} className="site-module-placeholder--line" style={{ width: randomLineWidthPercent() }} />
      ))}
    </SiteModule>
  );
}
